'use client'
import { useTranslations } from 'next-intl'
import { BaseEmptyStateProps } from '../types'
import { BaseEmptyState } from '../BaseEmptyState'

export const EmptyArticles: React.FC<BaseEmptyStateProps> = (props) => {
  const t = useTranslations('emptyStates.articles')

  return (
    <BaseEmptyState
      {...props}
      title={t('title')}
      description={t('description')}
      imageSrc="/emptyStates/product-illustration.svg"
      variant="subtle"
      className="lg:mb-[80px] mb-mobile-grid-gutter"
    />
  )
}
